import type { ReactNode } from "react";
import { Popover } from "@base-ui/react/popover";
import styles from "./Tooltip.module.css";
import useDialogPortalContainer from "../../hooks/use-dialog-portal-container.ts";
import Text from "./Text.tsx";

type Side = "top" | "bottom" | "left" | "right";

interface TooltipProps {
  content: ReactNode;
  direction?: Side;
  children: ReactNode;
}

export default function Tooltip({
  content,
  direction = "top",
  children,
}: TooltipProps) {
  const { container, triggerRef } = useDialogPortalContainer();
  return (
    <Popover.Root>
      <Popover.Trigger
        ref={triggerRef}
        render={<div>{children}</div>}
        nativeButton={false}
        className={styles.trigger}
        openOnHover
        delay={200}
        closeDelay={0}
      />
      <Popover.Portal container={container}>
        <Popover.Positioner
          side={direction}
          sideOffset={4}
          className={styles.positioner}
        >
          <Popover.Popup className={styles.popup}>
            <Text as="div" color="white">
              {content}
            </Text>
            <Popover.Arrow className={styles.arrow} />
          </Popover.Popup>
        </Popover.Positioner>
      </Popover.Portal>
    </Popover.Root>
  );
}
